import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import urologyBg1 from '../../assets/img/clinic/7.png';
import urologyBg2 from '../../assets/img/clinic/8.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Laparoscopy = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [urologyBg1,urologyBg2];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Laparoscopy and GI Surgery</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Laparoscopy and GI Surgery</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Laparoscopy and GI Surgery at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Laparoscopy and GI Surgery at Hitkari Hospital</h3>
                                     <p>At Hitkari Hospital, we are committed to offering advanced surgical solutions through our Laparoscopy and Gastrointestinal (GI) Surgery Department. Combining expertise, innovation, and patient-focused care, our department is designed to provide precise and minimally invasive treatments for abdominal and gastrointestinal conditions.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>What is Laparoscopy?</h3>
                                      <br />
                                      <p>Laparoscopy, often called keyhole surgery, is a minimally invasive procedure that uses a laparoscope—a small, lighted camera inserted through tiny incisions. This advanced surgical method allows surgeons to diagnose and treat various abdominal issues without the need for large incisions.</p>
                                      <p><strong>Key Benefits for Patients:</strong></p>
                                      <ul>
                                            <li>Minimal scarring and reduced risk of infection.</li>
                                            <li>Shorter hospital stays and quicker recovery times.</li>
                                             <li>Reduced postoperative discomfort compared to traditional surgeries.</li>
                                       </ul>

                                </div>
                                 <div className="terms-text">
                                    <h3>Comprehensive Services in GI Surgery</h3>
                                    <br />
                                       <p>Our Gastrointestinal (GI) Surgery Division specializes in treating conditions related to the digestive system, including the esophagus, stomach, intestines, liver, pancreas, and bile ducts. The focus is on delivering effective treatment with minimal disruption to the patient’s daily life.</p>
                                       <p><strong>Conditions We Treat:</strong></p>
                                         <ul>
                                                <li><strong>Gallbladder Diseases:</strong> Removal of gallstones or gallbladder (cholecystectomy).</li>
                                                <li><strong>Hernias:</strong> Both open and laparoscopic repairs for inguinal, umbilical, and incisional hernias.</li>
                                                <li><strong>Appendicitis:</strong> Quick and efficient laparoscopic appendectomy.</li>
                                                <li><strong>GERD and Acid Reflux:</strong> Surgical correction for chronic heartburn and reflux disorders.</li>
                                                 <li><strong>Colorectal Disorders:</strong> Management of colorectal cancer, diverticulitis, and inflammatory bowel diseases like Crohn’s disease and ulcerative colitis.</li>
                                               <li><strong>Liver and Pancreatic Diseases:</strong> Treatment of cysts, tumors, and chronic conditions.</li>
                                               <li><strong>Bariatric (Weight Loss) Surgery:</strong> Procedures designed to treat obesity and its related health issues.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital for Laparoscopy and GI Surgery?</h3>
                                    <br />
                                    <ul>
                                         <li><strong>Expert Team:</strong> Our skilled surgeons specialize in both minimally invasive and open surgical techniques, ensuring safe and effective treatment.</li>
                                           <li><strong>Advanced Technology:</strong> Equipped with the latest laparoscopic systems and imaging tools, we prioritize precision in every procedure.</li>
                                            <li><strong>Patient Education:</strong> We provide detailed consultations to help patients understand their condition and treatment options, empowering them to make informed decisions.</li>
                                           <li><strong>Comprehensive Care:</strong> From initial diagnosis to post-surgery recovery, we ensure every step of your journey is smooth and supported.</li>
                                          <li><strong>Holistic Recovery Plans:</strong> Emphasis on faster recovery, better outcomes, and improved quality of life.</li>
                                    </ul>
                                </div>
                                  <div className="terms-text">
                                    <h3>What to Expect During Laparoscopy or GI Surgery?</h3>
                                    <br />
                                     <ul>
                                           <li><strong>Pre-Surgery Assessment:</strong> Our team conducts thorough diagnostic evaluations, including imaging tests, blood work, and consultations.</li>
                                           <li><strong>The Procedure:</strong> Performed in our state-of-the-art operating rooms, surgeries are conducted under general anesthesia using the most advanced techniques.</li>
                                            <li><strong>Post-Surgery Care:</strong> Patients benefit from close monitoring and tailored recovery plans, ensuring a safe return to their normal routine.</li>
                                      </ul>
                                </div>
                                <div className="terms-text">
                                      <h3>State-of-the-Art Facilities at Hitkari Hospital</h3>
                                    <br />
                                    <p>Our hospital features cutting-edge operating theaters equipped with high-definition imaging systems, robotic-assisted surgery tools, and advanced sterilization protocols. This ensures every procedure is performed with the highest level of precision and safety.</p>
                                </div>
                                 <div className="terms-text">
                                     <h3>Adding Value to Your Health</h3>
                                     <p>At Hitkari Hospital, we believe in not just treating the condition but enhancing your overall well-being. Our minimally invasive laparoscopic techniques reduce hospital stays and recovery times, allowing you to get back to the life you love, faster and healthier.</p>
                                        <p>Contact us today to learn more about our Laparoscopy and GI Surgery services. Your health is our mission, and your recovery is our goal.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <footer className="footer">
          {/* Footer Top */}
          <div className="footer-top">
              <div className="container-fluid">
                  <div className="row">
                      <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-about">
                              <div className="footer-logo">
                                  <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                              </div>
                              <div className="footer-about-content">
                                  <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                  <div className="social-icon">
                                      <ul>
                                          <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                          <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-menu">
                              <h2 className="footer-title">For Patients</h2>
                              <ul>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                  <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                  <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                  <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-menu">
                              <h2 className="footer-title"
                              >
                                  For Patients
                              </h2>
                              <ul>
                                  <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                  <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                  <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                  <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                              </ul>
                          </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-contact">
                              <h2 className="footer-title">Contact Us</h2>
                              <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                  <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                      <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                          <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                                              <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                              <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                              <span>PIN – 344022</span>
                                          </div>
                                      </a>
                                  </div>
                                  <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                      <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                          <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                          02988-223100
                                      </a>
                                  </p>
                                  <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                      <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                          <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                          hitkarihospitalblt2015@gmail.com
                                      </a>
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="footer-bottom">
              <div className="container-fluid">
                  <div className="copyright">
                      <div className="row">
                          <div className="col-md-6">
                              <div className="copyright-text">
                                  <p className="mb-0">
                                      <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                  </p>
                              </div>
                          </div>
                          <div className="col-md-6">
                              <div className="copyright-menu">
                                  <ul className="policy-menu">
                                      <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </footer>
        </>
    );
};

export default Laparoscopy;